// Новый экран — сверху, и на iPhone тоже (регресс 26.10.2026: после «Дальше — образ» образ
// открылся внизу). ScrollRestoration ставит прокрутку в начало, но на iOS инерция
// пролистывания прошлого экрана продолжается и после смены адреса и уносит новый экран вниз.
// Поэтому на кадр страница перестаёт прокручиваться — инерция обрывается — и прокрутка
// ставится в начало ещё раз. Если человек сам начал листать новый экран, его не дёргаем.
import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router";

// Сколько ждать, пока инерция точно кончилась.
const SETTLE_MS = 300;
const USER_SCROLL_EVENTS = ["touchstart", "wheel", "keydown"] as const;

export function resetScrollToTop(): () => void {
  const root = document.documentElement;
  const previousOverflow = root.style.overflow;
  let userScrolls = false;
  const noteUserScroll = () => {
    userScrolls = true;
  };
  for (const eventName of USER_SCROLL_EVENTS) {
    window.addEventListener(eventName, noteUserScroll, { passive: true });
  }
  // Только на телефоне: на компьютере полоса прокрутки мигнула бы и сдвинула страницу.
  const stopsMomentum = window.matchMedia?.("(pointer: coarse)").matches === true;
  if (stopsMomentum) root.style.overflow = "hidden";
  window.scrollTo(0, 0);
  const frame = window.requestAnimationFrame(() => {
    root.style.overflow = previousOverflow;
    if (!userScrolls) window.scrollTo(0, 0);
  });
  const timer = window.setTimeout(() => {
    if (!userScrolls && window.scrollY > 0) window.scrollTo(0, 0);
    stopListening();
  }, SETTLE_MS);
  function stopListening() {
    for (const eventName of USER_SCROLL_EVENTS) {
      window.removeEventListener(eventName, noteUserScroll);
    }
  }
  return () => {
    window.cancelAnimationFrame(frame);
    window.clearTimeout(timer);
    root.style.overflow = previousOverflow;
    stopListening();
  };
}

// Новый экран (другой путь, не «назад» и не якорь) — сверху. «Назад» возвращает прокрутку
// через ScrollRestoration; смена только параметров адреса (выбор покупки) прокрутку не трогает.
export function useScrollToTopOnNewScreen() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    if (navigationType === "POP" || hash !== "") return;
    return resetScrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- только при смене экрана
  }, [pathname]);
}
